<template>
  <li :class="getItemCssClass(arena)" >
    <div @click="onClick(arena)">
      <span @click="toggle($event)" v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span>
      <strong  >{{arena.name}}</strong>
<!--      <p>{{arena.domain}}</p>-->
    </div>
    <ArenasTree v-show="isOpen" v-if="isFolder" :arenas="arena.children"/>
  </li>
</template>

<script>
//  import ArenasTreeItem from './ArenasTreeItem.vue'
  import config from '../../../config'
  const ArenasTreeItem = {
    name: 'ArenasTreeItem',
    components: {ArenasTree: () => import('./ArenasTree.vue') },
    props: {
      arena: Object,
      selectedArena: Object
    },
    data: function () {
      return {
        isOpen: false,
      }
    },
    computed: {
      isFolder: function () {
        return this.arena.children &&
          this.arena.children.length
      }
    },
    methods: {
      onClick: function (arena) {
        this.getArena(arena)
      },
      toggle: function (event) {
        if (event) {
          event.preventDefault()
        }
        if (this.isFolder) {
          this.isOpen = !this.isOpen
        }
      },
      getArena: function (arena) {
        this.isArenaLoading = true
        this.$http.get(`${config.apiUrl}/arena/get?domain=${arena.domain}`).then(response => {
          let _arena = response.body
          this.isArenaLoading = false
          this.$emit('choseArena', {
            meta: arena,
            data: _arena
          })
        }, error => {
          console.log(error)
          this.$emit('choseArena', null)
          this.isArenaLoading = false
        })
      },
      getItemCssClass: function (arena) {
        const classStr = this.isFolder ? 'item isFolder' : 'item'
        return this.selectedArena != null && this.selectedArena.meta === arena ? classStr + ' selected' : classStr
      }
    }
  }

export default ArenasTreeItem;
</script>
<style scoped>
  li.isFolder{
    background: azure;
  }
  li {
    padding: 3px;
  }
  li.selected{
    background-color: #D4DBF0;
  }
</style>
